import createMuiTheme, {
  Theme,
  ThemeOptions,
} from '@material-ui/core/styles/createMuiTheme';
import {
  Palette,
  PaletteOptions,
} from '@material-ui/core/styles/createPalette';

import defaultFont from 'ha/constants/fonts/default';

import createMaxWidths, { MaxWidths } from './createMaxWidths';
import * as CustomColors from './colors';

interface CustomSpacing {
  formRow: number;
  navHeight: number;
}
interface CustomSpacingOptions {
  formRow?: number;
  navHeight?: number;
}

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    warning: PaletteColor;
    ok: PaletteColor;
    mint: PaletteColor;
    white: PaletteColor;
  }

  // `createMuiTheme`'s parameter, used to customize/extend theme
  interface PaletteOptions {
    ok: PaletteColor;
    mint: PaletteColor;
    white: PaletteColor;
  }
}

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    maxWidths: MaxWidths;
    palette: Palette;
    customSpacing: CustomSpacing;
  }

  // `createMuiTheme`'s parameter, used to customize/extend theme
  interface ThemeOptions {
    maxWidths?: MaxWidths;
    palette?: PaletteOptions;
    customSpacing?: CustomSpacingOptions;
  }
}

interface Options extends ThemeOptions {
  // we want to make pallete a not optional property
  palette?: PaletteOptions;
}

export function createMyTheme(options: Options): Theme {
  return createMuiTheme({
    maxWidths: createMaxWidths(),
    ...options,
    palette: {
      primary: CustomColors.primary,
      secondary: CustomColors.secondary,
      error: CustomColors.negative,
      grey: CustomColors.grey,
      ok: CustomColors.positive,
      warning: CustomColors.warning,
      mint: CustomColors.mint,
      white: CustomColors.white,
      ...options.palette,
    },
    typography: {
      fontFamily: defaultFont.fontFamily,
      fontSize: 14,
      ...options.typography,
    },
    customSpacing: {
      formRow: 1.4,
      navHeight: 56,
    },
  });
}

const theme = createMyTheme({});

export default theme;
